import { useEffect } from 'react';
import { AuthForm } from "../../components/Login/AuthForm";
import { TokenExpired } from '../../components/TokenExpired';
import { useTokenExpiration } from '../../hooks/useTokenExpiration';

export function Login() {
  const {checkTokenExpiration,showModalExpirated} = useTokenExpiration();

  useEffect(()=>{
    checkTokenExpiration();   
  },[]);

  return (
    <div 
    className="flex  w-full h-[50%] font-sans  bg-no-repeat bg-center bg-cover bg-fd-login7 justify-start items-center  "
    >
      <div 
      className="w-full h-screen flex items-center justify-center lg:items-end lg:justify-start lg:w-[380px] min-h-[51rem] lg:ml-[308px]"
      >
        {showModalExpirated  &&
          <TokenExpired/>
        }
        <AuthForm />
      </div>
    </div>
  );
}
